export default function Project7() {
    return (
        <div>
            <iframe title="Presentation: Development of Advanced Space Robotics Technologies to Enable Challenging In-Space Operations for ISAM and Space Logistics" src="https://docs.google.com/presentation/d/e/2PACX-1vRd7uteg4tNTne_xw-XuaeL6upzo_i4tfMxslprWe4ntgVbz-XK3FOy2IqeUjdf7w/embed?start=false&loop=false&delayms=5000" frameborder="0" width="100%" className="h-[calc(100vh_-_107px)]" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
        </div>
    );
}
